
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import ElectricBill from "../components/electricbill";
import Footer from "../components/footer";

function ElectricBillPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <ElectricBill /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default ElectricBillPage;
